module.exports = __webpack_public_path__ + "static/ice_mephit-7e2fe773fa5266c345572fa077e376da.jpg";